
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kundenkonto",
      function () {
        return require("private-next-pages/kundenkonto/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kundenkonto"])
      });
    }
  